<div class="section-block mapping-details mb-3">
  <div class="row">
    @for (config of mappingConfigs; track config) {
      <div class="col-lg-4 mt-3">
        <div class="mapping-card">
          <div class="d-flex justify-content-between align-items-start mb-3">
            <p class="fs-15 fw-500 text-info2 w-75 text-uppercase mb-0">
              {{ config.label }}
            </p>
            @if (showButtons) {
              <button class="btn btn-info1 text-light btn-sm" type="button"
                (click)="onOpenPopup(config.popupKey)" data-bs-toggle="modal" data-bs-target="#mappingCardModal">
                + Add
              </button>
            }
          </div>
          <div class="selected-tags">
            @if (hasMappings(config.key)) {
              @for (item of getMappingItems(config.key); track item; let i = $index) {
                <span class="mapping-tag">
                  {{ getMappingItemName(item, config.key) }}
                  @if (showButtons) {
                    <a href="javascript:void(0)" (click)="removeMappingItem(config.key, i)">
                      <img src="/assets/images/uploads/close-red.svg" height="10" width="10"
                        alt="Remove" />
                    </a>
                  }
                </span>
              }
            } @else {
              <p class="mapping-empty text-muted mb-0">{{ config.emptyMessage }}</p>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>

<!-- Modal -->
<div class="modal fade" id="mappingCardModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="mappingCardModalLabel" aria-hidden="true">
  <div class="modal-dialog mapping-modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header py-2 bg-info1 text-light">
        <h1 class="modal-title fs-18" id="mappingCardModalLabel">
          {{ currentActivatedPopupItem.title }}
        </h1>
        <div>
          <button type="button" class="btn btn-info2 text-light rounded-circle" data-bs-dismiss="modal">
            <img src="/assets/images/uploads/close-white.svg" height="11px" />
          </button>
        </div>
      </div>
      <div class="modal-body px-0 py-0">
        <div class="px-4 d-flex justify-content-between bg-secondary py-2 border-bottom">
          <div class="d-flex align-items-center">
            <span class="me-4">{{ currentActivatedPopupItem.list.length }}
            {{ currentActivatedPopupItem.blockname }}</span>
          </div>
          <button class="btn btn-info1 border-0 text-white" (click)="addMappings()" data-bs-dismiss="modal">
            + ADD
          </button>
        </div>

        <ul class="checkbox-list px-0 m-0 overflow-auto">
          @for (popupItem of currentActivatedPopupItem.list; track popupItem; let i = $index) {
            <li class="px-4 py-2 border-bottom"
              [class.disabled-item]="popupItem.disabled"
              >
              <div class="form-check" for="flexCheckDefault">
                <input class="form-check-input" type="checkbox" [(ngModel)]="popupItem.checked"
                  [id]="'flexCheckDefault' + i"
                  [disabled]="popupItem.disabled" />
                <label class="form-check-label w-100"
                  [for]="'flexCheckDefault' + i"
                  [class.disabled-label]="popupItem.disabled">{{
                  getLabel(popupItem, currentActivatedPopupItem.type)
                }}</label>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>

